module.exports = {
  DISPLAY_FORMAT: 'L',
  ISO_FORMAT: 'YYYY-MM-DD',
  ISO_MONTH_FORMAT: 'YYYY-MM',

  START_DATE: 'startDate',
  END_DATE: 'endDate',

  HORIZONTAL_ORIENTATION: 'horizontal',
  VERTICAL_ORIENTATION: 'vertical',
  VERTICAL_SCROLLABLE: 'verticalScrollable',

  ICON_BEFORE_POSITION: 'before',
  ICON_AFTER_POSITION: 'after',

  ANCHOR_LEFT: 'left',
  ANCHOR_RIGHT: 'right',

  OPEN_DOWN: 'down',
  OPEN_UP: 'up',

  DAY_SIZE: 39,
  BLOCKED_MODIFIER: 'blocked',
  WEEKDAYS: [0, 1, 2, 3, 4, 5, 6],
};



//////////////////
// WEBPACK FOOTER
// ./~/react-dates/constants.js
// module id = 48
// module chunks = 0